import Api from '@/services/Api'

export default {
  getAddress (id) {
    return Api().get('address/' + id)
  },
  getShippingAddresses (idArray) {
    return Api().post('shippingAddresses', idArray)
  },
  createAddress (address) {
    return Api().post('addresses', address)
  }
}



// WEBPACK FOOTER //
// ./src/services/AddressService.js